<template>
  <b-row>
    <b-col
      v-if="method !== 3"
      md="12"
    >
      <b-form-group
        label="Action Link"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="action link"
          rules="required"
        >
          <b-form-input
            id="action-link"
            v-model="content.action_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label="Product Name"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="product_name"
          rules="required"
        >
          <b-form-input
            id="product-name"
            v-model="content.product_name"
            placeholder="Type your product name"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label="Product Registry Key"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="product registry key"
          rules="required"
        >
          <b-form-input
            id="product-registry-key"
            v-model="content.product_registry_key"
            placeholder="Type your product registry key"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="tarif"
          rules="required|regex:^([0-9]+)$"
        >
          <label for="campaign-description">
            Tariff
            <span
              class="text-warning"
            > (Include VAT 11%)</span>
          </label>
          <b-form-input
            id="tarif"
            v-model="content.tarif"
            placeholder="Type your tariff of service"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label="Frequency"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="frequency"
          rules="required"
        >
          <b-form-input
            id="frequency"
            v-model="content.frequency"
            placeholder="Type your frequency of service"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label="Shortcode"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="shortcode"
          rules="required|regex:^([0-9]+)$"
        >
          <b-form-input
            id="shortcode"
            v-model="content.shortcode"
            placeholder="97xxx"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="6"
    >
      <b-form-group
        label="Cs Number of Service"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="cs-number"
          rules="required"
        >
          <b-form-input
            id="cs-number"
            v-model="content.cs_number"
            placeholder="Type your cs number of service"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group
        label="Slot Type"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="slot type"
          rules="required"
        >
          <v-select
            id="slot-type"
            v-model="content.slot_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="(text) => text.value"
            label="text"
            :options="slotType"
            :state="errors.length > 0 ? false : null"
            @input="setSlot"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group
        label="Medium"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="medium"
          rules="required"
        >
          <v-select
            id="medium"
            v-model="medium_select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="text"
            :options="medium_new"
            :state="errors.length > 0 ? false : null"
            @input="setMedium"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- Selected Type VIDEO or IMAGE -->
    <!-- <b-col
      v-if="content.slot_type !== 3"
      md="12"
    >
      <b-form-group
        label="Media Type"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="choicemedia"
          rules="required"
        >
          <v-select
            id="choicemedia"
            v-model="content.media_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="text => text.value"
            label="text"
            :state="errors.length > 0 ? false:null"
            placeholder=""
            :options="selectItemContent"
            @input="handlersSelectedItemContent"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
    <!-- End Selected Type VIDEO or IMAGE -->
    <!-- Input Content Images -->
    <b-col
      v-if="content.media_type === 1 && content.slot_type === 3"
      md="6"
    >
      <b-form-group
        label="Banner 320 x 50 px"
        label-for="banner-landscape"
      >
        <validation-provider
          #default="{ errors }"
          name="banner landscape"
          rules="required|dimensions320x50"
        >
          <b-form-file
            id="banner-landscape"
            v-model="content.banner.landscape"
            name="banner-landscape"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="onFileChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="content.media_type === 1 && content.slot_type !== 3"
      md="6"
    >
      <b-form-group
        label="Banner 300 x 250 px"
        label-for="banner-potrait"
      >
        <validation-provider
          #default="{ errors }"
          name="banner potrait"
          rules="required|dimensions300x250"
        >
          <b-form-file
            id="banner-potrait"
            v-model="content.banner.potrait"
            name="banner-potrait"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="onFileChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="content.media_type === 1 && content.slot_type === 3 && $store.state.campaign.formCampaign.method_id === 3"
      md="6"
    >
      <b-form-group>
        <label
          class="label-note"
          for="banner-expand"
          data-note="(Image dimensions are 300 x 250 pixel)"
        >
          Thumbnail
        </label>
        <validation-provider
          #default="{ errors }"
          name="banner thumbnail"
          rules="required|dimensions300x250"
        >
          <b-form-file
            id="banner-potrait"
            v-model="content.bannerThumbnail"
            name="banner-potrait"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="handleThumbnailUpload"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <b-col
      v-if="content.media_type === 1 && content.slot_type === 2"
      md="6"
    >
      <b-form-group>
        <label
          class="label-note"
          for="banner-expand"
          data-note="(Image dimensions are 240 x 400 pixel)"
        >
          Expand Banner
        </label>
        <validation-provider
          #default="{ errors }"
          name="banner expand"
          rules="required|dimensions240x400"
        >
          <b-form-file
            id="banner-expand"
            v-model="content.bannerThumbnail"
            name="banner-expand"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="handleThumbnailUpload"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- End Input Content Images -->
    <!-- Input Content Thumbnail & Video -->
    <b-col
      v-if="content.media_type === 2"
      md="6"
    >
      <b-form-group>
        <label
          class="label-note"
          for="banner-thumbnail"
          data-note="(Image dimensions are 300 x 250 pixel)"
        >
          Video Thumbnail
        </label>
        <validation-provider
          #default="{ errors }"
          name="banner thumbnail"
          rules="required|dimensions300x250"
        >
          <b-form-file
            id="banner-thumbnail"
            v-model="content.bannerThumbnail"
            name="banner-thumbnail"
            accept="image/*"
            placeholder="Upload Thumbnail"
            :state="errors.length > 0 ? false : null"
            @change="handleThumbnailUpload"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="content.media_type === 2"
      md="6"
    >
      <b-form-group>
        <label
          class="label-note"
          for="video-file"
          data-note="(Max duration is 30 seconds, max size is 5MB and mp4 format)"
        >
          Video
        </label>
        <validation-provider
          #default="{ errors }"
          name="video file"
          rules="required|ext:mp4|validateVideo|size:5000"
        >
          <b-form-file
            id="video-file"
            v-model="content.fileVideo"
            name="video-file"
            accept="video/*"
            placeholder="Upload Video"
            :state="errors.length > 0 ? false : null"
            @change="handleFileUploadVideo"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- End Input Content Thumbnail & Video -->
    <img
      :src="url"
      alt=""
    >
  </b-row>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormFile,
} from 'bootstrap-vue'
import { regex, size, ext } from 'vee-validate/dist/rules'
import { ValidationProvider, extend } from 'vee-validate'
import vSelect from 'vue-select'
import { mapGetters, mapMutations } from 'vuex'

// ieu validasi hese
// eslint-disable-next-line no-unused-vars
const util = file => new Promise((resolve, reject) => {
  let reader = new FileReader()
  reader.onload = e => {
    let data = e.target.result
    let img = new Image()
    img.src = data
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
  }
  reader.readAsDataURL(file)
})

// eslint-disable-next-line no-unused-vars
const utilVideo = file => new Promise((resolve, reject) => {
  let reader = new FileReader()
  reader.onload = e => {
    let aud = new Audio(e.target.result)
    aud.onloadedmetadata = () => {
      resolve({
        duration: aud.duration,
        data: aud,
      })
    }
  }
  reader.readAsDataURL(file)
})

extend('regex', {
  ...regex,
  message: 'This {_field_} field must be numeric!',
})

extend('ext', {
  ...ext,
  message: 'This {_field_} field must be mp4!',
})

extend('dimensions320x50', {
  message: 'File dimensions {_field_} field must be 320 x 50 pixel',
  validate: async value => {
    let img = await util(value)
    if (img.width === 320 && img.height === 50) return true
    return false
  },
})

extend('size', {
  ...size,
  message: 'File size can\'t be more 5MB!',
})

extend('validateVideo', {
  message: 'File duration of video must be maximum 30 second',
  validate: async value => {
    let vid = await utilVideo(value)
    // console.log(vid)
    if (vid.duration <= 30) return true
    return false
  },
})

extend('dimensions300x250', {
  message: 'File dimensions {_field_} field must be 300 x 250 pixel',
  validate: async value => {
    let img = await util(value)
    if (img.width === 300 && img.height === 250) return true
    return false
  },
})

extend('dimensions240x400', {
  message: 'File dimensions {_field_} field must be 240 x 400 pixel',
  validate: async value => {
    let img = await util(value)
    if (img.width === 240 && img.height === 400) return true
    return false
  },
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    ValidationProvider,
    vSelect,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      medium_new: [],
      medium_all: [{
        text: 'All',
        value: 0,
      }],
      selectItemContent: [
        {
          text: 'Images',
          value: 1,
        },
        {
          text: 'Video',
          value: 2,
        },
      ],
      medium_select: '',
      content: {
        slot_type: 1,
        slot_type_name: 'Underlay',
        medium: [],
        medium_name: [],
        action_link: '',
        product_registry_key: '',
        product_name: '',
        shortcode: '',
        frequency: '',
        tarif: '',
        cs_number: '',
        banner: [
          {
            landscape: null,
          },
          {
            potrait: null,
          },
        ],
        media_type: 1,
        fileVideo: null,
        bannerThumbnail: null,
      },
      url: '',
    }
  },
  computed: {
    ...mapGetters('datas', {
      slotType: 'getSlotType',
      medium: 'getMedium',
    }),
    ...mapGetters('campaign', {
      bannerLandscapeUrl: 'getBannerLandscape',
      bannerPotraitUrl: 'getBannerPotrait',
    }),
  },
  mounted() {
    this.medium_new = []
    this.medium_new = [...this.medium, ...this.medium_all]
    // console.log(this.medium, this.medium_all)
  },
  methods: {
    ...mapMutations('campaign', {
      setLandscapeUrl: 'SET_BANNER_LANDSCAPE_URL',
      setPotraitUrl: 'SET_BANNER_POTRAIT_URL',
      setFileVideoUrl: 'SET_FILE_VIDEO_URL',
      setBannerThumbnailUrl: 'SET_BANNER_THUMBNAIL_URL',
    }),
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content
    },
    // Selected Item Content
    handlersSelectedItemContent(value) {
      if (value === 1) {
        this.setFileVideoUrl('')
        this.setBannerThumbnailUrl('')
        this.$store.state.campaign.formCampaign.fileVideo = null
      } else if (value === 2) {
        this.setLandscapeUrl('')
        this.setPotraitUrl('')
        this.$store.state.campaign.formCampaign.landscape = null
        this.$store.state.campaign.formCampaign.potrait = null
      }
    },
    // End Selected Item Content
    // Video Handler
    handleFileUploadVideo(e) {
      const fileVideo = e.target.files[0]
      if (typeof (fileVideo) !== 'undefined') {
        this.$store.state.campaign.formCampaign.fileVideo = fileVideo
        this.setFileVideoUrl(URL.createObjectURL(fileVideo))
      }
    },
    // End Video Handler
    // Thumbnail Handler
    handleThumbnailUpload(e) {
      const thumbnailVideo = e.target.files[0]
      if (typeof (thumbnailVideo) !== 'undefined') {
        this.$store.state.campaign.formCampaign.bannerThumbnail = thumbnailVideo
        this.setBannerThumbnailUrl(URL.createObjectURL(thumbnailVideo))
      }
    },
    // End Thumbnail Handler
    onFileChange(e) {
      const file = e.target.files[0]
      if (e.target.id === 'banner-landscape') {
        this.$store.state.campaign.formCampaign.landscape = file
        this.setLandscapeUrl(URL.createObjectURL(file))
      }
      if (e.target.id === 'banner-potrait') {
        this.$store.state.campaign.formCampaign.potrait = file
        this.setPotraitUrl(URL.createObjectURL(file))
        if (this.$store.state.campaign.formCampaign.method_id === 3) {
          this.$store.state.campaign.formCampaign.bannerThumbnail = file
          this.setBannerThumbnailUrl(URL.createObjectURL(file))
        }
      }
    },
    getText(arr, i) {
      const data = arr.find(item => item.value === i)
      return data.text
    },
    resetDataBanner() {
      this.setLandscapeUrl('')
      this.setPotraitUrl('')
      this.setFileVideoUrl('')
      this.setBannerThumbnailUrl('')
      this.$store.state.campaign.formCampaign.landscape = null
      this.$store.state.campaign.formCampaign.potrait = null
      this.$store.state.campaign.formCampaign.fileVideo = null
      this.$store.state.campaign.formCampaign.bannerThumbnail = null
      this.content.banner.potrait = null
      this.content.banner.landscape = null
      this.content.bannerThumbnail = null
      this.content.fileVideo = null
    },
    setSlot(val) {
      // this.content.slot_type_name = []
      // val.forEach(data => {
      if (val === 5) {
        this.content.media_type = 2
      } else {
        this.content.media_type = 1
      }

      this.content.slot_type_name = this.getText(this.slotType, val)
      this.resetDataBanner()
      // })
    },
    setMedium(val) {
      this.content.medium = []
      this.content.medium_name = []
      // val.forEach(data => {
      // this.content.medium_name.push(this.getText(this.medium, val))
      // console.log(this.content.medium, this.content.medium_name)
      this.content.medium.push(val.value)
      this.content.medium_name.push(val.text)

      if (val.value === 0 || val.text === 'All') {
        this.content.medium = []
        this.content.medium_name = []
        const textMedium = this.medium.map(item => item.text)
        const valMedium = this.medium.map(item => item.value)
        this.content.medium = valMedium
        this.content.medium_name = textMedium
      }
      // console.log(this.content.medium, this.content.medium_name)
      // })
    },
  },
}
</script>
<style scoped>
</style>
